import { EnvVarsService } from '@multitenancy-spa/env-vars-service/esm/services/env-vars-service';

const checkIsInEditor = (): boolean => {
	const mockIsInEditor = EnvVarsService.getVar('VITE_IS_IN_EDITOR', true);
	if (mockIsInEditor) return true;

	const currentLocation =
		window.location != window.parent.location
			? document.referrer
			: document.location.href;
	const isInEditor = currentLocation.includes('/editor.html/');

	return isInEditor;
};

const useIsInEditor = (): boolean => checkIsInEditor();

export { useIsInEditor, checkIsInEditor };
